module.exports = __webpack_public_path__ + "img/works_procurement_system_app_2.99c0ce3a.png";